// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:11:35

export default {
  "id": "go-to-zero",
  "slug": "go-to-zero",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cae8e8dbe3764de493932c4fdbb23ec2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cae8e8dbe3764de493932c4fdbb23ec2/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Go To Zero",
      "description": "Test your math skills in Go To Zero! Merge numbers and mathematical symbols to bring the result down to zero. Clear the screen and solve handcrafted puzzles that challenge your logic and calculation abilities!",
      "instructions": "Combine numbers and math symbols to reach zero.\nClear all elements from the screen to complete each level.\nUse logic and strategy to solve increasingly challenging puzzles!",
      "genres": [
        "Educational",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "2d",
        "math"
      ]
    },
    "zh-CN": {
      "title": "归零",
      "description": "在《归零挑战》中测试你的数学技能！合并数字和数学符号，将结果降至零。清除屏幕，解决精心设计的谜题，挑战你的逻辑和计算能力！",
      "instructions": "将数字和数学符号组合以得到零。\n清除屏幕上的所有元素以完成每个关卡。\n运用逻辑和策略解决越来越具有挑战性的谜题！",
      "genres": [
        "教育类",
        "益智游戏"
      ],
      "tags": [
        "1玩家",
        "2D",
        "数学"
      ]
    },
    "zh-TW": {
      "title": "回到零點",
      "description": "在「Go To Zero」中挑戰你的數學能力！合併數字與數學符號，將結果降低至零。清空畫面，解決精心設計的謎題，挑戰你的邏輯與計算能力！",
      "instructions": "合併數字與數學符號，達到零。\n清除螢幕上所有元素，完成每個關卡。\n使用邏輯和策略解決越來越挑戰性的謎題！",
      "genres": [
        "教育性",
        "謎題"
      ],
      "tags": [
        "1 玩家",
        "2D",
        "數學"
      ]
    },
    "zh-HK": {
      "title": "歸零",
      "description": "在「Go To Zero」中挑戰你的數學能力！合併數字及數學符號，將結果帶至零。清空螢幕，解開獨特設計的謎題，挑戰你的邏輯及計算能力！",
      "instructions": "將數字及數學符號組合以達到零。\n清除畫面所有元素以完成每個關卡。\n使用邏輯及策略解決越來越挑戰性的謎題！",
      "genres": [
        "教育性",
        "謎題"
      ],
      "tags": [
        "1人遊戲",
        "2D",
        "數學"
      ]
    },
    "ja": {
      "title": "ゼロに戻る",
      "description": "ゴー・トゥ・ゼロ！で数学のスキルを試してみましょう！数字や数学記号をマージして結果をゼロに引き下げましょう。スクリーンをクリアし、論理と計算能力を試す手作りのパズルを解きましょう！",
      "instructions": "数字と数学記号を組み合わせてゼロにすることを目指せ。\nスクリーン上のすべての要素をクリアして、各レベルを完了せよ。\n論理と戦略を使って、次第に難しくなるパズルを解決せよ！",
      "genres": [
        "教育的",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "数学"
      ]
    },
    "ko": {
      "title": "제로로 가기",
      "description": "Go To Zero에서 수학 기술을 테스트하세요! 숫자와 수학 기호를 합치고 결과를 0으로 내려보세요. 화면을 지우고 논리적 사고와 계산 능력을 도전하는 고도로 만들어진 퍼즐을 해결하세요!",
      "instructions": "숫자와 수학 기호를 결합하여 0에 도달하세요.\n화면에 있는 모든 요소를 지우고 각 레벨을 완료하세요.\n로직과 전략을 사용하여 점점 더 어려운 퍼즐을 해결하세요!",
      "genres": [
        "교육용",
        "패uzzle"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "수학"
      ]
    },
    "fr": {
      "title": "Aller à zéro",
      "description": "Testez vos compétences en mathématiques dans Go To Zero ! Fusionnez des nombres et des symboles mathématiques pour faire tomber le résultat à zéro. Effacez l'écran et résolvez des puzzles conçus pour défier votre logique et vos capacités de calcul !",
      "instructions": "Combinez des nombres et des symboles mathématiques pour atteindre zéro.\nEffacez tous les éléments de l'écran pour terminer chaque niveau.\nUtilisez la logique et la stratégie pour résoudre des puzzles de plus en plus complexes !",
      "genres": [
        "Éducatif",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "mathématiques"
      ]
    }
  }
};
